import { Directive, HostListener, input } from '@angular/core'

@Directive({
  selector: 'img[libImageFallback]',
})
export class ImageFallbackDirective {
  libImageFallback = input.required<string>()

  @HostListener('error', ['$event.target'])
  onError(target: EventTarget | null) {
    if (target) {
      const t = target as HTMLImageElement
      t.src = this.libImageFallback()
    }
  }
}
